var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 24,
    viewBox: "0 0 159 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6601 0.433838V8.37955C5.07205 8.50144 6.47687 8.69534 7.86905 8.96045V4.54428H19.7588V0.433838H3.6601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.752 18.788V22.9697H3.66009V12.9892C2.69193 13.0843 1.73735 13.2304 0.796368 13.4138L0.436279 13.475V9.6227L0.684265 9.58193C5.32329 8.77268 10.0671 8.76922 14.7073 9.57174L14.9519 9.61251V13.4648L14.6122 13.4002C12.3944 12.982 10.1429 12.7682 7.88603 12.7616V18.7846L19.752 18.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2596 11.5116C43.3548 17.2085 39.8626 22.9733 31.9916 22.9733H23.4786V0.433838H31.9916C39.7165 0.433838 43.1611 5.94047 43.2596 11.5116ZM27.6943 18.8833H31.9916C37.111 18.8833 39.1254 15.1465 39.0405 11.4777C38.9454 7.96851 36.8834 4.45935 31.9916 4.45935H27.6943V18.8833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5952 0.467773V13.3766C65.5952 20.0416 61.5188 23.4557 55.8389 23.4557C50.4308 23.4557 45.8278 20.1707 45.8278 13.3766V0.467773H50.0367V13.3766C50.0367 17.4327 52.3535 19.5898 55.8627 19.5898C59.3718 19.5898 61.3693 17.2425 61.3693 13.3766V0.467773H65.5952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.067 0.444092H70.8607V23.466H158.067V0.444092Z",
    fill: "#4F72EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3071 11.9498C78.3071 7.9752 81.2217 5.17603 84.8736 5.17603C88.5254 5.17603 91.4537 7.9752 91.4537 11.9498C91.4537 15.9243 88.5424 18.7439 84.8736 18.7439C81.2048 18.7439 78.3071 15.9277 78.3071 11.9498ZM89.7518 11.9498C89.7518 8.77011 87.6728 6.65375 84.8736 6.65375C82.0744 6.65375 79.992 8.77011 79.992 11.9498C79.992 15.1294 82.071 17.2458 84.8736 17.2458C87.6762 17.2458 89.7518 15.1328 89.7518 11.9498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.877 5.33565H105.521V18.5842H103.744L96.5765 7.94459V18.5774H94.9289V5.32886H96.7056L103.877 15.9583V5.33565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.381 17.0997H117.795V18.5774H109.716V5.32886H111.381V17.0997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 18.5774V5.32886H122.764V18.5774H121.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.928 5.33594H137.576V18.5845H135.796L128.628 7.95167V18.5845H126.98V5.33594H128.76L135.928 15.9653V5.33594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.432 17.12H150.62V18.5774H141.757V5.32886H150.488V6.7828H143.432V11.0767H149.333V12.534H143.432V17.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.303,
    height: 23.1,
    fill: "white",
    transform: "translate(0.0999756 0.399902)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelogo);
export default __webpack_public_path__ + "static/media/whitelogo.382aea218558b25214f5b396bc8124c0.svg";
export { ForwardRef as ReactComponent };